import * as Yup from "yup";

export const integrationSchema = Yup.object().shape({
    provider: Yup.string()
        .oneOf(["evolution", "openai", "gemini"])
        .required("O provedor é obrigatório."),
    name: Yup.string().required("O nome da integração é obrigatório."),
    isActive: Yup.boolean().default(true),
    
    // Validamos 'config' internamente dependendo do provider
    config: Yup.object()
        .when("provider", {
            is: "evolution",
            then: () => Yup.object().shape({
                apiUrl: Yup.string().url("URL inválida").required("A URL da API é obrigatória"),
                apiKey: Yup.string().required("A Global API Key é obrigatória"),
                instanceName: Yup.string().required("O nome da instância é obrigatório"),
                webhookUrl: Yup.string().url("URL inválida").nullable()
            }),
            otherwise: (schema, { value }) => schema
        })
        .when("provider", {
            is: "openai",
            then: () => Yup.object().shape({
                apiKey: Yup.string().required("A chave da API é obrigatória"),
                organizationId: Yup.string().nullable(),
                defaultModel: Yup.string().required("O modelo padrão é obrigatório"),
                systemPrompt: Yup.string().nullable()
            }),
            otherwise: (schema, { value }) => schema
        })
        .when("provider", {
            is: "gemini",
            then: () => Yup.object().shape({
                apiKey: Yup.string().required("A chave da API é obrigatória"),
                defaultModel: Yup.string().required("O modelo padrão é obrigatório"),
                systemPrompt: Yup.string().nullable()
            }),
            otherwise: (schema, { value }) => schema
        })
});
